// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__1b68E","logo":"Login_logo__2u07u","link":"Login_link__1u1a2","TandC":"Login_TandC__3nNdp"};